import { cn } from '#/lib/utils';
import {
  Popover as ShadcnPopover,
  PopoverAnchor as ShadcnPopoverAnchor,
  PopoverContent as ShadcnPopoverContent,
  PopoverDescription as ShadcnPopoverDescription,
  PopoverHeader as ShadcnPopoverHeader,
  PopoverTitle as ShadcnPopoverTitle,
  PopoverTrigger as ShadcnPopoverTrigger,
} from '#/modules/commonComponents/shadcn/ui/popover';

/** ERP 樣式掛點（換皮只改此檔，禁止改 vendor） */
const POPOVER_CONTENT_ERP_CLASS = '';

function PopoverContent({ className, ...props }) {
  return (
    <ShadcnPopoverContent
      className={cn(POPOVER_CONTENT_ERP_CLASS, className)}
      {...props}
    />
  );
}

export {
  ShadcnPopover as Popover,
  ShadcnPopoverTrigger as PopoverTrigger,
  PopoverContent,
  ShadcnPopoverAnchor as PopoverAnchor,
  ShadcnPopoverHeader as PopoverHeader,
  ShadcnPopoverTitle as PopoverTitle,
  ShadcnPopoverDescription as PopoverDescription,
};
